import React, { useState } from 'react';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '..';
import Typography from '@mui/material/Typography';
import { TELEFONIA_MODALS } from 'src/utils/constants';
import { toast } from 'react-toastify';

const ModificarEstadoAni = (props) => {
  const { open, close, flag, afterConfirm } = props;
  const { fetch } = useFetch();

  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);
  const confirmHandler = async () => {
    const nuevo_estado = flag === TELEFONIA_MODALS.HABILITAR_ANI ? 3 : 0;
    await fetch(`/telefonia/anis/${props.data.id}`, {
      method: 'PATCH',
      data: { estado: nuevo_estado },
    })
      .then((res) => toast.success('Cambio realizado exitosamente.'))
      .catch((error) => {
        toast.error('No se pudo realizar el cambio');
        console.log(error);
      });
    afterConfirm();
    close();
  };

  return (
    <Modal
      title={
        flag === TELEFONIA_MODALS.DESHABILITAR_ANI
          ? 'Deshabilitar ANI'
          : 'Habilitar Ani'
      }
      content={
        <>
          {/* <Box sx={{ minWidth: 120, p: 1 }}>
            <FormControl fullWidth focused color="grey">
              <InputLabel id="login-type-select">Estado</InputLabel>
              <Select
                fullWidth
                size="small"
                labelId="login-type-select"
                value={estadoAni}
                label="Estado"
                name="estado"
                onChange={handleChange}
              >
                <MenuItem value={0}>Inactivo</MenuItem>
                <MenuItem value={1}>Disponible</MenuItem>
                <MenuItem value={2}>Portado a otra Empresa</MenuItem>
                <MenuItem value={3}>Asignado</MenuItem>
              </Select>
            </FormControl>
          </Box> */}

          <Typography>¿Estás seguro de efectuar este cambio? </Typography>
        </>
      }
      open={open}
      close={onCloseModal}
      showConfirmButton={true}
      onConfirm={confirmHandler}
    />
  );
};

export default ModificarEstadoAni;
